import script from "./DnsDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DnsDataTable.vue?vue&type=script&setup=true&lang=js"

import "./DnsDataTable.vue?vue&type=style&index=0&id=61964ad1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61964ad1"]])

export default __exports__